module.exports = "<div #container style=\"display: none\"></div>\n"